import React from 'react'
import cx from 'classnames'

import { Alert } from 'components/shared/Alert/Alert'

import styles from './ActionAlert.module.scss'

type ActionAlertProps = Pick<
  React.ComponentProps<typeof Alert>,
  | 'buttonColor'
  | 'buttonLabel'
  | 'buttonSize'
  | 'buttonVariant'
  | 'className'
  | 'message'
  | 'variant'
  | 'onAction'
  | 'isInitialised'
>

export const ActionAlert = ({
  buttonColor = 'primary',
  buttonLabel,
  buttonSize = 'small',
  buttonVariant = 'filled',
  className,
  message,
  variant,
  onAction,
  isInitialised,
}: ActionAlertProps) => {
  return (
    <Alert
      className={cx(styles.alert, className)}
      {...{
        buttonColor,
        buttonLabel,
        buttonSize,
        buttonVariant,
        message,
        variant,
        onAction,
        isInitialised,
      }}
    >
      <Alert.Message />
      <Alert.ActionButton />
    </Alert>
  )
}
